import { differenceWith } from "lodash";
import { BOT_SUBSCRIPTIONS_RECEIVED, USER_LOGGED_IN, UPDATE_USER_DOMAIN_ROLES, UPDATE_USER, USER_PROFILE_IMAGE, UPDATE_BANNER, VOIP_STATUS, LICENSE_STATUS, CLEAR_LOGGED_IN_USER_CALL_HISTORY, UPDATE_LOGGED_IN_USER_CALL_HISTORY, UPDATE_SELECTED_CONTACT_CALL_HISTORY, UPDATE_CALL_HISTORY, UPDATE_PHONE_BALANCE, UPDATE_SOFTWARE_MFA, DE_GENERATING_PUSH_NOTIFICATIONS, GENERATING_PUSH_NOTIFICATIONS } from "../constants";
import { updateDataInStorage } from "../../services/storage/LocalStorage";
import { pushNotificationsApiRequest } from "../actions/user";

let initialState = {
	isOnline: navigator.onLine,
	botSubscriptions: [],
	user: null,
	auth: null,
	profileImage: null,
	balance: 0,
	bannerDetails: {},
	voipStatus: {},
	isLicenseValid: true,
	callHistory: [],
	loggedInUserCallHistory: [],
	timeStampOfLastRecordInRcvdCallHistoryForLoggedInUser: null,
	hasMoreRecords: true,
	contactsCallHistory: {},
};

const userReducer = (state = initialState, action) => {
	switch (action.type) {
		case USER_LOGGED_IN:
			return {
				...state,
				user: action.data.user,
				auth: action.data.auth,
				isAnonymousUser: action.data.isAnonymousUser,
			};

		case BOT_SUBSCRIPTIONS_RECEIVED:
			return {
				...state,
				botSubscriptions: action.data.botSubscriptions,
			};
		case VOIP_STATUS:
			return { ...state, voipStatus: { ...action.data } };
		case LICENSE_STATUS:
			return {
				...state,
				isLicenseValid: action.data,
			};
		case UPDATE_USER_DOMAIN_ROLES:
			return {
				...state,
				user: {
					...state.user,
					domains: action?.data?.domains
				}
			};
		case UPDATE_CALL_HISTORY:
			return {
				...state,
				...action.payload,
			};
		case UPDATE_SELECTED_CONTACT_CALL_HISTORY: {
			const { callHistory, selectedContactId } = action.payload;
			let updatedContactCallHistory = state.contactsCallHistory;
			updatedContactCallHistory[selectedContactId] = callHistory
				? callHistory.content
				: [];

			return {
				...state,
				contactsCallHistory: updatedContactCallHistory,
			};
		}
		case UPDATE_LOGGED_IN_USER_CALL_HISTORY: {
			let rcvdCallHistory = action.payload.records;
			let moreRecordsExist = action.payload.moreRecordsExist;
			// rcvdCallHistory.sort((a, b) => b.callTimestamp - a.callTimestamp)
			const exCallHistory = state.loggedInUserCallHistory;

			const customResults = differenceWith(
				rcvdCallHistory,
				exCallHistory,
				(rcvdCallRecord, exCallRecord) =>
					exCallRecord.callTimestamp === rcvdCallRecord.callTimestamp
			);
			// console.log("customResults", customResults);
			exCallHistory.push(...customResults);
			exCallHistory.sort((a, b) => b.callTimestamp - a.callTimestamp);

			const timeStampOfLastRecordInExCallHistoryForLoggedInUser =
				exCallHistory &&
					exCallHistory[exCallHistory.length - 1] &&
					exCallHistory[exCallHistory.length - 1].callTimestamp
					? exCallHistory[exCallHistory.length - 1].callTimestamp
					: null;


			return {
				...state,
				loggedInUserCallHistory: exCallHistory,
				timeStampOfLastRecordInExCallHistoryForLoggedInUser:
					timeStampOfLastRecordInExCallHistoryForLoggedInUser,
				hasMoreRecords: moreRecordsExist,
			};
		}
		case CLEAR_LOGGED_IN_USER_CALL_HISTORY:
			return {
				...state,
				loggedInUserCallHistory: [],
				timeStampOfLastRecordInRcvdCallHistoryForLoggedInUser: null,
				hasMoreRecords: true,
			};
		case UPDATE_USER: {
			const updatedUserData = Object.assign({}, state.user, action.data.user);
			updateDataInStorage("user", updatedUserData);
			return {
				...state,
				user: updatedUserData,
			};
		}
		case GENERATING_PUSH_NOTIFICATIONS:
			let dataToGenerate = action.data;
			if (dataToGenerate) {
				pushNotificationsApiRequest(dataToGenerate);
			}
			return {
				...state,
			};
		case DE_GENERATING_PUSH_NOTIFICATIONS:
			let dataToDEgenrate = action.data;
			if (dataToDEgenrate) {
				pushNotificationsApiRequest(dataToDEgenrate);
			}
			return {
				...state,
			};
		case UPDATE_BANNER:
			return {
				...state,
				bannerDetails: {
					...action.data,
				},
			};
		case USER_PROFILE_IMAGE:
			return {
				...state,
				profileImage: action.payload,
			};
		case UPDATE_PHONE_BALANCE:
			return {
				...state,
				...action.payload,
			};
		case UPDATE_SOFTWARE_MFA:
			return {
				...state,
				user: {
					...state.user,
					softwareMfaEnabled: action.data,
				},
			};

		default:
			return state;
	}
};

export default userReducer;
